import api from '@pray/shared/utils/api';

export type IpAddressInfo = {
  ip: string;
  pools: string[];
  warmup: boolean;
  start_date: number | null;
  subusers: string[];
};

export type DomainReputation = {
  domain: string;
  health_score: number;
  health_level: 'healthy' | 'warning' | 'danger' | 'neutral';
  google_reputation: 'HIGH' | 'MEDIUM' | 'LOW' | 'BAD' | null;
};

export type EmailHealthReputationResponse = {
  domain_reputation: DomainReputation;
  ip_addresses: IpAddressInfo[];
};

export type GetEmailHealthReputationParams = {
  start_date: string;
  end_date: string;
};

export async function getEmailHealthReputation({
  start_date,
  end_date,
}: GetEmailHealthReputationParams): Promise<EmailHealthReputationResponse> {
  const params: Record<string, string> = { start_date, end_date };

  const url = '/web/studio/system-check/email-health/reputation';
  const response = await api.executeGetRequest<{ data: EmailHealthReputationResponse }>(url, params);

  return response.data.data;
}
